const Config = {
  app_storage_prefix: "teamsite-qa",
  api_server: "/api",
  socket_server: "/",
  auth: {
    clientId: "645cb98eda766024cad3cd86",
  }
};
export default Config;
